import React, { lazy, Suspense, useEffect } from 'react'
import { Route } from 'react-router-dom'
import RequireUserLevel from 'src/Elements/RequireUserLevel/RequireUserLevel'
import { SHOP_ACCESS } from 'src/Configuration/user'
import { useDispatch } from 'react-redux'
import { updateShopAccess } from 'src/State/Shop/ShopAction'
import { SuspenseRoot } from '@e3dc-react/shell/Elements/Suspense'
import { UserData } from 'src/State/User/UserModel'

const TermsAndConditions = lazy(() => import('../../../Routes/Shop/TermsAndConditions/TermsAndConditions'))
const ShippingCosts = lazy(() => import('src/Routes/Shop/ShippingCosts/ShippingCosts'))

interface Props {
  user: UserData | undefined
  userLoading: boolean
}

/**
 * Default shop routes.
 */
const useDefaultShopRoutes = ({ user, userLoading }: Props): React.ReactElement[] => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateShopAccess(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [
    <Route
      key="shop-shipping-costs"
      path="/shop/shipping-costs"
      element={
        <RequireUserLevel userLevel={user?.level ?? 'USER'} allowedRoles={SHOP_ACCESS} loading={userLoading}>
          <ShippingCosts />
        </RequireUserLevel>
      }
    />,
    <Route
      key="shop-terms-and-conditions"
      path="/shop/terms-and-conditions"
      element={
        <Suspense fallback={<SuspenseRoot />}>
          <TermsAndConditions />
        </Suspense>
      }
    />,
  ]
}

export default useDefaultShopRoutes
